module.exports = __webpack_public_path__ + "img/41-ACY.63b34a1.png";